import * as React from "react";
import { GeneralNumericQuestion } from "./generalNumericQuestion";
import { useTranslate } from "../../../../hooks/useTranslate";
import { QuestionsIF } from "../../QuestionsIF";

//region [[ Styles ]]
//endregion [[ Styles ]]

//region [[ Props ]]

export interface SmokingQuestionProps extends QuestionsIF {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SmokingQuestion = ({ ...props }: SmokingQuestionProps) => {
  const { translate } = useTranslate();

  // We wrap around the generic numeric question just to have a placeholder
  // saying 'years' or 'packs-per-day' - i've suggested using the units but
  // product wanted it hard codded 🤷🏻

  // Check if it's a packs for day questions - super hacky I know
  const isPacksPerDay =
    props.question?.suggestions?.[0]?.suggestion?.id ===
    "FE.e0a83c43-47a8-4fc4-96ff-cda74cf07c2e_RE.b7a0556b-820e-4a0c-a89c-5a4f25436d7f_0_100_NA";

  return (
    <GeneralNumericQuestion
      {...props}
      converters={null}
      placeholder={isPacksPerDay ? null : translate("SMOKING_PLACEHOLDER")}
    />
  );
};
